// extracted by mini-css-extract-plugin
module.exports = {"praise":"_1kArKxT3KVc1_aDoQ7lCOp"};